import { useEffect } from "react";
import { useEditorFocusChanged } from "../utils/use-editor-focus-changed";

import type { FC } from "react";

export const FocusChangedPlugin: FC<{ onChange: (focused: boolean) => void }> = ({ onChange }) => {
  const focused = useEditorFocusChanged();

  useEffect(() => {
    onChange(focused);
  }, [onChange, focused]);

  return null;
};
